export const ConvertToPictureObject = ((picture: any): UI.Picture => {
	if (picture === null) return null;
	if (picture === undefined) return null;
	if (picture.items === undefined) return null;

	const pictures: UI.Picture[] = [];

	picture.items.forEach((item) => {
		const altTextChecked = item.content.properties.altText == '""' ? '' : item.content.properties.altText;
		if (item.content.properties.image.length === 0) return null;
		const image = item.content.properties.image[0];
		const imageHeight = Number(image.height);
		const imageWidth = Number(image.width);
		const object:UI.Picture = {
			altText: altTextChecked,
			aspectRatio: image.extension !== 'svg' ? imageHeight > 0 && imageWidth > 0 ? imageHeight / imageWidth : 9 / 16 : null,
			focalPoint:  image.extension !== 'svg' ? image.focalPoint : {
				left: 0.5,
				top: 0.5, 
			},
			height:  image.extension !== 'svg' ? imageHeight : 0,
			url: image.url,
			width:  image.extension !== 'svg' ? imageWidth : 0,
		}
		pictures.push(object);
	});
	if (pictures.length > 0)
		return pictures[0];
	return null;
}); 